import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import companiesApi from "../../api/companiesApi";
import styles from "./CreateCompanyPage.module.css";

export default function CreateCompanyPage() {
  const navigate = useNavigate();
  const [companyName, setCompanyName] = useState("");
  const [imageFile, setImageFile] = useState(null);
  const [error, setError] = useState("");
  const [saving, setSaving] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    const name = companyName.trim();
    if (!name) {
      setError("El nombre de la empresa es obligatorio.");
      return;
    }

    setError("");
    setSaving(true);
    try {
      const formData = new FormData();
      formData.append("name", name);
      if (imageFile) formData.append("logo", imageFile, imageFile.name);

      const { company } = await companiesApi.createCompany(formData);
      navigate(`/company/${company._id}`, {
        replace: true,
        state: { fromCreation: true },
      });
    } catch (requestError) {
      console.error("Error creando empresa:", requestError);
      setError(requestError.response?.data?.message || "No se pudo crear la empresa.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.steps} aria-label="Progreso de configuración">
        <span className={styles.stepActive}>1. Empresa</span>
        <span>2. Sucursales</span>
        <span>3. Configuración opcional</span>
      </div>

      <h2 className={styles.title}>Crear empresa</h2>
      <p className={styles.helper}>
        Comienza con los datos generales. En el siguiente paso agregarás al menos una sucursal.
      </p>

      <form onSubmit={handleSubmit} className={styles.form}>
        <div className={styles.section}>
          <label htmlFor="companyName" className={styles.label}>Nombre de la empresa</label>
          <input
            id="companyName"
            type="text"
            className={styles.input}
            value={companyName}
            onChange={(event) => setCompanyName(event.target.value)}
            autoFocus
          />
        </div>

        <div className={styles.section}>
          <label htmlFor="companyLogo" className={styles.label}>Logo (opcional)</label>
          <input
            id="companyLogo"
            type="file"
            accept="image/*"
            className={styles.hiddenFileInput}
            onChange={(event) => setImageFile(event.target.files[0] || null)}
          />
          <button
            type="button"
            className={styles.fileButton}
            onClick={() => document.getElementById("companyLogo").click()}
          >
            {imageFile?.name || "Seleccionar logo"}
          </button>
        </div>

        {error && <p className={styles.error}>{error}</p>}

        <div className={styles.buttonRow}>
          <button type="button" className={styles.cancelButton} onClick={() => navigate("/empresas")}>Cancelar</button>
          <button type="submit" className={styles.submitButton} disabled={saving}>
            {saving ? "Creando..." : "Continuar a sucursales"}
          </button>
        </div>
      </form>
    </div>
  );
}
